import { EOrientation } from "$src/CGS/domain/dto/core/EOrientation";

export abstract class InsideComputation {
    public abstract get minHeight(): number;
    public abstract get maxHeight(): number | null;
    public abstract get minWidth(): number;
    public abstract get maxWidth(): number | null;

    public getMin(orientation: EOrientation): number {
        return orientation === EOrientation.Horizontal ? this.minWidth : this.minHeight;
    }

    public getMax(orientation: EOrientation): number | null {
        return orientation === EOrientation.Horizontal ? this.maxWidth : this.maxHeight;
    }
}